<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="6">
            <el-input size="medium" placeholder="搜索关键字: 姓名、手机" v-model="key" style="width: 97%;"></el-input>
          </el-col>
          <el-col :span="7">
            <el-button size="medium" type="primary" icon="el-icon-search" @click="searchIntegral">搜索</el-button>
          </el-col>
          <el-col :span="8">
            &nbsp;
          </el-col>
          <el-col :span="3">
            &nbsp;
            <el-button size="medium" type="success" @click="openDialog('add', null)" v-if="checkButtonPermission('integral:manage:apply')">兑换积分</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="name" label="姓名" min-width="70"></el-table-column>
          <el-table-column prop="telephone" label="手机号码" min-width="70"></el-table-column>
          <el-table-column prop="currentIntegral" label="当前积分" min-width="70"></el-table-column>
          <el-table-column prop="operationIntegral" label="兑换积分" min-width="70"></el-table-column>
          <el-table-column prop="surplusIntegral" label="剩余积分" min-width="70"></el-table-column>
          <!--<el-table-column prop="orderId" label="订单号" min-width="70"></el-table-column>-->
          <el-table-column prop="status" label="状态" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">待处理</span>
              <span v-else-if="scope.row.status == 1">已取消</span>
              <span v-else-if="scope.row.status == 2">已完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="applyTime" label="申请时间" min-width="140"></el-table-column>
          <!--<el-table-column prop="userName" label="操作人" min-width="70"></el-table-column>
          <el-table-column prop="userName" label="操作时间" min-width="70"></el-table-column>-->
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-button
                @click="openDialog('edit', scope.row)"
                type="success" size="mini" v-if="(scope.row.status === 0 || scope.row.status === 1) && checkButtonPermission('integral:manage:edit')"
              >编辑
              </el-button>
              <el-button
                @click="deleteIntegral(scope.row.integralOrderId)"
                type="danger"
                size="mini"
                v-if="checkButtonPermission('integral:manage:delete')"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination
            background
            @current-change="currentPageChange"
            @size-change="pageSizeChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="integralDialogTitle + '积分兑换'"
               :visible.sync="dialogVisible"
               :modal="false"
      :close-on-click-modal="false"
               @closed="resetForm('integralForm')"

    >
      <el-form :model="integralForm"
               ref="integralExchangeForm"
               :rules="integralFormRules"
               label-width="120px"
               size="medium"
               style="padding: 0 10%;"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="integralForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="telephone">
          <el-input v-model="integralForm.telephone" clearable></el-input>
        </el-form-item>
        <el-form-item label="当前积分" prop="currentIntegral">
          <el-input v-model="integralForm.currentIntegral" clearable></el-input>
        </el-form-item>
        <el-form-item label="兑换积分" prop="operationIntegral">
          <el-input v-model="integralForm.operationIntegral" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <!--<el-input v-model="integralForm.status" clearable></el-input>-->
          <el-select v-model="statusSelect" @change="statusSelectChange">
            <el-option
              v-for="status in statusSelectOptions"
              :label="status.label"
              :value="status.value"
              :key="status.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary" @click="submitForm('integralForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Clipboard from 'clipboard';
  import {reqCode, dialogAction} from '@/common/const';
  export default {
    name: "integralList",
    data() {
      return {
        key: '',
        addFlag: 'add',
        tableData: [],
        currentPage: 1,
        pageSize: 20,
        totalPage: 100,
        total: 100000,
        dialogVisible: false,
        integralDialogTitle: '编辑',
        integralForm: {},
        integralFormRules: {
          telephone: [
            { required: true, message: "请输入手机号", trigger: "blur" },
            // 这个只能验证手机号
            // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
            { pattern:/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" }
          ]
        },
        statusSelect: '',
        statusSelectOptions: [
          {
            label: '待处理',
            value: '0',
          },
          {
            label: '已取消',
            value: '1',
          },
          {
            label: '已完成',
            value: '2',
          },
        ],
      }
    },

    created() {
      this.searchIntegral();
    },
    methods: {
      searchIntegral() {
        let reqParam = {
          key: this.key,
          size: this.pageSize,
          currentPage: this.currentPage,
        };
        this.$http.post('/api/integral-service/logged/integralExchange/search', reqParam,{
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          console.log(resp);
          let data = resp.data;
          if ("success" === data.code) {
            let pageInfo = data.pageInfo;
            this.tableData = pageInfo.list;
            this.pageSize = pageInfo.pageSize;
            this.total = pageInfo.total;
            this.totalPage = pageInfo.pages;
          }
          else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(response => {
          console.log("========");
          if(response.response.data == 401){
            this.$router.push({path: '/login'});
          }else{
            this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
              confirmButtonText: '确定'
            });
          }

        })
      },
      deleteIntegral(integralOrderId) {
        this.$confirm('此操作将永久该积分信息, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('/api/integral-service/integralExchange/delete?integralOrderId=' + integralOrderId).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.dialogVisible = false;
              this.$message({
                message: '删除积分信息成功',
                type: 'success'
              });
              this.searchIntegral();
            } else {
              this.$alert(''  + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
            this.$alert(''  + e, '温馨提示', {
              confirmButtonText: '确定'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      openDialog(dialogOperation, data) {
        this.dialogVisible = true;
        this.dialogOperation = dialogOperation;
        if (dialogAction.ADD == dialogOperation) {
          this.dialogTitle = '新增';
          //this.channelCategoryVal = '1';
        } else if (dialogAction.EDIT == dialogOperation) {
          this.dialogTitle = '编辑';
          let temp = {};
          Object.assign(temp, data);
          console.log(temp);
          this.integralForm = temp;

          // 回显数据
          //let name = temp.name;
          //let telephone = temp.telephone;

          //let currentIntegral = temp.currentIntegral;
          //let operationIntegral = temp.operationIntegral;

          let status = data.status;
          // 绑定状态
          if(status == 0) {
            this.statusSelect = '待处理';
          } else if(status == 1) {
            this.statusSelect = '已取消';
          } else if (status == 2) {
            this.statusSelect = '已完成';
          }

        }
      },
      submitForm(formName) {
        this.$refs.integralExchangeForm.validate((valid) => {
          if (valid) {
            if (dialogAction.ADD == this.dialogOperation) {
              this.integralForm.status = this.dialogStatusVal;
              this.addIntegralExchange(formName);
            } else if (dialogAction.EDIT == this.dialogOperation) {
              console.log('edit');
              this.integralForm.status = this.dialogStatusVal;
              this.updateIntegralExchange(formName);
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      addIntegralExchange(formName) {
        this.$http.post('/api/integral-service/integralExchange/add', this.integralForm).then(resp => {
          console.log(resp);
          let data = resp.data;
          let code = data.code;
          if (data.code === "success") {
            this.$message({
              message: '成功添加一条积分信息',
              type: 'success'
            });
            this.dialogVisible = false;
            //this.resetForm();
            this.searchIntegral();
          } else {
            this.$alert(data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }

        }).catch(response => {
          this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
            confirmButtonText: '确定'
          });
        })
      },
      updateIntegralExchange(formName) {

        this.$http.post('/api/integral-service/integralExchange/update', this.integralForm).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.$message({
              message: '编辑积分信息成功',
              type: 'success'
            });
            this.dialogVisible = false;
            //this.resetForm();
            this.searchIntegral();
          } else {
            this.$alert(data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(response => {
          this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
            confirmButtonText: '确定'
          });
        })

      },

      openDialogEvent(addFlag){
      },
      statusSelectChange(val) {
        this.dialogStatusVal = val;
      },
      currentPageChange(val) {
        this.currentPage = val;
        this.searchIntegral();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this.searchIntegral();
      },
      resetForm(formName) {
        this.integralForm = {};
        //  this.$refs[formName].resetFields();
      },
      checkButtonPermission(perms) {
        let menuPermsList = sessionStorage.getItem("menuPermsList");
        if (menuPermsList.indexOf(perms) != -1) {
          return true
        } else {
          return false;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/integral/integralList.vue